import React from 'react';
import Nabvar from '../Components/Navbar/Navbar';
import Demo from '../Pages/Demo/Demo';
import PwaInstallPrompt from '../Components/PwaInstallPrompt/PwaInstallPrompt';

export default function IndexLayout() {
    return (
        <div className='section-bg-color'>
            <Nabvar />
            <Demo />
            <PwaInstallPrompt />
        </div>
    );
}
